import {
  IS_NOTIFICATION_RECEIVED,
  SET_NOTIFICATION_TEXT,
} from "constants/ActionTypes";

const INIT_STATE = {
  isNotificationReceived: false,
  Notification: { title: "", body: "" },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case IS_NOTIFICATION_RECEIVED: {
      return {
        ...state,
        isNotificationReceived: false,
        Notification: { title: "", body: "" },
      };
    }
    case SET_NOTIFICATION_TEXT: {
      return {
        ...state,
        isNotificationReceived: true,
        Notification: {
          title: action.payload.title,
          body: action.payload.body,
        },
      };
    }
    default:
      return state;
  }
};
